import {
    ON_START_NEW_EVENT,
    ON_NEW_EVENT,
    ON_ERROR_NEW_EVENT,
    ON_START_GET_EVENT_ORGNR,
    ON_GET_EVENT_ORGNR,
    ON_ERROR_GET_EVENT_ORGNR,
    ON_START_GET_EVENT_ID,
    ON_GET_EVENT_ID,
    ON_ERROR_GET_EVENT_ID,
    ON_START_GET_EVENT_USER,
    ON_GET_EVENT_USER,
    ON_ERROR_GET_EVENT_USER,
    ON_START_GET_EVENT_USER_DATE,ON_START_GET_EVENT_USER_DATE1,
    ON_GET_EVENT_USER_DATE,
    ON_ERROR_GET_EVENT_USER_DATE,
    ON_START_EVENT_UPDATE,ON_START_GET_EVENT_USER_DONTREFRESH,
    ON_EVENT_UPDATE,ON_START_EVENT_OMBOKA,
    ON_ERROR_EVENT_UPDATE,ON_NEW_EVENT_AVTAL,ON_START_NEW_EVENT_AVTAL,ON_ERROR_NEW_EVENT_AVTAL,
    ON_START_EVENT_UPDATE_AvtalId, ON_EVENT_UPDATE_AvtalId, ON_ERROR_EVENT_UPDATE_AvtalId,
    ON_START_GET_EVENT_HISTORY_ID,ON_GET_EVENT_HISTORY_ID,ON_ERROR_GET_EVENT_HISTORY_ID,
    ON_START_EVENT_COMMENT, ON_EVENT_COMMENT, ON_ERROR_EVENT_COMMENT,
    ON_START_EVENT_UPDATE_KOM, ON_EVENT_UPDATE_KOM, ON_ERROR_EVENT_UPDATE_KOM,
    ON_START_EVENT_AVBOKA, ON_EVENT_AVBOKA, ON_ERROR_EVENT_AVBOKA,
    ON_MOTE_LIST_DIALER,ON_START_MOTE_LIST_DIALER,
    ON_START_EVENT_UPDATE_NYTT, ON_EVENT_UPDATE_NYTT, ON_ERROR_EVENT_UPDATE_NYTT,
    ON_START_GET_EVENT_ID_REFRESH,ON_GET_EVENT_ID_REFRESH,ON_ERROR_GET_EVENT_ID_REFRESH,
    ON_START_GET_EVENT_DOKUMENT,ON_GET_EVENT_DOKUMENT,ON_ERROR_GET_EVENT_DOKUMENT,
    ON_START_GET_EVENT_SETTING,ON_GET_EVENT_SETTING,ON_ERROR_GET_EVENT_SETTING,
    ON_START_SYNK_ENENTS, ON_SYNK_ENENTS, ON_ERROR_SYNK_ENENTS,
    SET_EVENTVY_TYPE,ON_GET_KUND_MOTE_ANTAL,SET_EVENTVY_PAGE_ROWS,
    ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,
    FETCH_START_SET_UNAUTHE
} from "../constants/ActionTypes";
import { history } from "store";
import axios from 'util/Api' 
import { isEmpty,isUndefined } from "lodash";
import {userSignOut} from 'actions'
import { translate } from "../util/intlHelper";
import {
  RefreshUserInterface,GetMinaMoteKampanj,getProspektByUserid1,getAvtalMote,getAvtalByRestID
} from 'actions'
import {encrypt,decrypt} from 'actions'

//
const getClientIp = async () => {
  let Ipadress='0.0.0.0'
    /**/  await fetch('http://ip-api.com/json')
      .then(response => response.json())
      .then(data => {console.log(data)
      Ipadress= data.query || "0.0.0.0"});
       return Ipadress
}


//createNewAvtal
export const createNewEvent = (userid,Afid,Nevent,isFrom) =>{
//createNewEvent//
    const jwt =  JSON.parse(localStorage.token);
    const formData = new FormData()
    console.log(isFrom,"isFrom")
     return async (dispatch) => {
      const ipAdress='0.0.0.0'
      let files = isEmpty(Nevent.Event.Files)?[]:Nevent.Event.Files; 
      delete Nevent.Event.Files;
     
      //files.forEach(file => fromdata.append('files[]', file));

      formData.append("Afid",Afid)
      formData.append("isFrom",isFrom)
      formData.append("userid",userid)
      formData.append("ipAdress",ipAdress)
      formData.append("Event",JSON.stringify(Nevent))
      files.forEach(file => formData.append('files[]', file));
      formData.append('files[]', files)

      if(isUndefined(isFrom)){
       dispatch({type: ON_START_NEW_EVENT});
       dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Event.Creating")});
      }else  if(isFrom === 'Avtal'){
        dispatch({type: ON_START_NEW_EVENT_AVTAL});
      }else if(isFrom === 'Kund'){
        dispatch({type: ON_START_GET_EVENT_ORGNR});
        dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Event.Creating")});
      }
       axios.post('kontos/Event/new', 
       formData,
        {
          method: 'POST',
          body:{
            Event:JSON.stringify(Nevent),
            Afid:Afid,isFrom,
            userid:userid,ipAdress
          },
          headers: {
            'content-type': 'multipart/form-data',
            'Authorization':   `Bearer ${jwt}`
           }
        }    
    ).then(({data}) => {
        console.log("createNewEvent: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           
           if(isUndefined(isFrom)){
            dispatch({type: ON_NEW_EVENT, payload: data.results});
            history.push({
            pathname: '/app/Moteskort',
            state: { MoteId: data.results.Event.Event }
            });
           }
           else if(isFrom === 'Avtal'){
            dispatch({type: ON_NEW_EVENT_AVTAL, payload: data.results});
            dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
            dispatch(getAvtalMote(Afid,userid,Nevent.Avtal))
           }else if(isFrom === 'Kund'){
            dispatch(getMoteByOrgnr(userid,Afid,Nevent.Kund.Orgnr,0));
            dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Event.Create",`Möte #19${data.results.Event.Event[0].id} har skapats`,{item:data.results.Event.Event[0].id})});
           }
           
         } else {
          if(isUndefined(isFrom)){
            dispatch({type: ON_ERROR_NEW_EVENT, payload: data.error});
           }else  if(isFrom === 'Avtal'){
            dispatch({type: ON_ERROR_NEW_EVENT_AVTAL, payload: data.error});
           }else if(isFrom === 'Kund'){
            dispatch({type: ON_ERROR_NEW_EVENT, payload: data.error});
            dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Event.Create")});
          }
           
         }
         ////dispatch(RefreshUserInterface(userid))
         let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
         dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
       }).catch(function (error) {
        if(isUndefined(isFrom)){
          dispatch({type: ON_ERROR_NEW_EVENT, payload: error.message});
         }else  if(isFrom === 'Avtal'){
          dispatch({type: ON_ERROR_NEW_EVENT_AVTAL, payload: error.message});
         }else if(isFrom === 'Kund'){
          dispatch({type: ON_ERROR_NEW_EVENT, payload: error.message});
          dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Event.Create")});
        }
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
     }
   } 
//getMoteByOrgnr
export const getMoteByOrgnr = (userid,Afid,Orgnr,page,type,searchWord) =>{
  let Page = isUndefined(page)?0:page
  let Type = isUndefined(type)?0:type
  let SearchWord = isUndefined(searchWord)?"":searchWord
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_EVENT_ORGNR});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Event.fetching")});
    axios.get('kontos/Event/getByOrgnr',
    { params:encrypt(JSON.stringify({
      Orgnr:Orgnr,Afid:Afid,userid:userid,
      page:Page,
      Type:Type,
      SearchWord:SearchWord,
      ipAdress})),

     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getMoteByOrgnr: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getMoteByOrgnr1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_EVENT_ORGNR, payload: ndate.results});
        dispatch({type: ON_GET_KUND_MOTE_ANTAL,payload: ndate.results})
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Event.fetch")});
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addArtikel2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_EVENT_ORGNR, payload: ndate.error});
        dispatch({type: ON_ERROR_MESSAGE_KUND,payload:translate("Error.Event.fetch")});
      }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_EVENT_ORGNR, payload: error.message});
       dispatch({type: ON_ERROR_MESSAGE_KUND,payload:"transalate:Error.Event.fetch"});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getMoteByIDRefresh
export const getMoteByIDRefresh = (Orgrn,Afid,userid,Event) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_EVENT_ID_REFRESH});
    axios.get('kontos/Event/getById',
    { params:encrypt(JSON.stringify({Orgnr:Orgrn,Afid:Afid,userid:userid,Event:Event,ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(( data ) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("getMoteByIDRefresh1: ", ndate);
        dispatch({type: ON_GET_EVENT_ID_REFRESH, payload: ndate.results});
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("getMoteByIDRefresh3: ", ndate);
        dispatch({type: ON_ERROR_GET_EVENT_ID_REFRESH, payload: ndate.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_EVENT_ID_REFRESH, payload: error.message});
       if(error.message === "Network Error"){
       } 
     }); 
  }
}
//
export const onRefeshOutlookTokenEvent = (event,Afid) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    await axios.get('users/Event/refresh/outlook', { 
      params:encrypt(JSON.stringify({Afid:Afid,
        event:event,ipAdress})), 
      headers: { 'Authorization': `Bearer ${jwt}`} }
    )
    
    }
}
//getMoteByID
export const getMoteByID = (Orgrn,Afid,userid,Event,Page) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch(onRefeshOutlookTokenEvent(Event,Afid))
    dispatch({type: ON_START_GET_EVENT_ID});
    dispatch({type: ON_START_MOTE_LIST_DIALER});
    axios.get('kontos/Event/getById',
    { params:encrypt(JSON.stringify({Orgnr:Orgrn,Afid:Afid,userid:userid,Event:Event,ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getMoteByID: ", data);
      dispatch(RefreshUserInterface(userid))
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("getMoteByID1: ", ndate);
        if(isUndefined(Page)){
          history.push({
            pathname: '/app/Moteskort',
            state: { MoteId: ndate.results.Event.Event}
          });
        }else{
          dispatch({type: ON_MOTE_LIST_DIALER});
        }
          dispatch({type: ON_GET_EVENT_ID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("getMoteByID3: ", ndate);
        dispatch({type: ON_ERROR_GET_EVENT_ID, payload: ndate.error});
      }
     
      //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_EVENT_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
//getMoteHistoryById
export const getMoteHistoryById = (Orgrn,Afid,userid,Event,Page) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_EVENT_HISTORY_ID});
    axios.get('kontos/Event/getHistoryById',
    { params:encrypt(JSON.stringify({Orgnr:Orgrn,Afid:Afid,userid:userid,Event:Event,ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getMoteHistoryById: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("getMoteHistoryById1: ", ndate);
        dispatch({type: ON_GET_EVENT_HISTORY_ID, payload: ndate.results});   
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("getMoteHistoryById3: ", ndate);
        dispatch({type: ON_ERROR_GET_EVENT_HISTORY_ID, payload: ndate.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_EVENT_HISTORY_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}

//getMoteByUserID
export const getMoteByUserID = (Afid,Filterstate,userid,Page,searchWord, Type,DontRefresh,pageRows) =>{
  Type = isUndefined(Type) ? 0 : Type
  Page = (isUndefined(Page)?0:Page)
  DontRefresh = (isUndefined(DontRefresh)?0:DontRefresh)
  searchWord = (isUndefined(searchWord)?"":searchWord)
  pageRows = (isUndefined(pageRows)?25:pageRows)
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    if(DontRefresh === 1){
      dispatch({type: ON_START_GET_EVENT_USER_DONTREFRESH});      
    }
    else{
      dispatch({type: ON_START_GET_EVENT_USER});
    }
    
    axios.get('kontos/Event/getByUser',
    { params:encrypt(JSON.stringify({Afid:Afid,userid:userid,Page:Page,
      pageRows:pageRows,
      searchWord:searchWord,Filterstate:Filterstate,Type:Type,ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getOrderByUserID: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("getOrderByUserID1: ", ndate);
        dispatch({type: ON_GET_EVENT_USER, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("getOrderByUserID3: ", ndate);
        dispatch({type: ON_ERROR_GET_EVENT_USER, payload: ndate.error});
      }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_EVENT_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//

//getMoteByUserIDByDate
export const getMoteByUserIDByDate33 = (Afid,userid,userList,Start,End,callbackFunc,callbackFunc1) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    const ipAdress='0.0.0.0'
    if(!isUndefined(callbackFunc)){
      callbackFunc()
    }
    dispatch({type: ON_START_GET_EVENT_USER_DATE1});
    axios.get('kontos/Event/getByUserdate',
    { params:encrypt(JSON.stringify({Afid:Afid,userid:userid,Start:Start,End:End,ipAdress,userList,checkFilter:1}))
      , 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getOrderByUserID: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("getOrderByUserID1: ", ndate);
        dispatch({type: ON_GET_EVENT_USER_DATE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("getOrderByUserID3: ", ndate);
        dispatch({type: ON_ERROR_GET_EVENT_USER_DATE, payload: ndate.error});
      }
       if(!isUndefined(callbackFunc1)){
        callbackFunc1()
      }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_EVENT_USER_DATE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const getMoteByUserIDByDate = (Afid,userid,userList,Start,End,callbackFunc,callbackFunc1) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    const ipAdress='0.0.0.0'
    if(!isUndefined(callbackFunc)){
      callbackFunc()
    }
    dispatch({type: ON_START_GET_EVENT_USER_DATE});
    axios.get('kontos/Event/getByUserdate',
    { params:encrypt(JSON.stringify({Afid:Afid,userid:userid,Start:Start,End:End,ipAdress,userList})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data  => {
      console.log("getOrderByUserID: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("getOrderByUserID1: ", ndate);
        dispatch({type: ON_GET_EVENT_USER_DATE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("getOrderByUserID3: ", ndate);
        dispatch({type: ON_ERROR_GET_EVENT_USER_DATE, payload: ndate.error});
      }
      if(!isUndefined(callbackFunc1)){
        callbackFunc1()
      }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_EVENT_USER_DATE, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//SaveThisEvent
export const SaveThisEvent =  (Afid,userid,Event,MotesPage) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_EVENT_UPDATE});
      axios.put('kontos/Event/update', {
       body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        Event:Event,ipAdress
       }))},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("SaveThisEvent: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("SaveThisEvent1: ", ndate);
        dispatch({type: ON_EVENT_UPDATE, payload: ndate.results});
        if(parseInt(MotesPage) === 1){
          dispatch(GetMinaMoteKampanj(Afid,userid))
        }
       }
       else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("SaveThisEvent3: ", ndate);
        dispatch({type: ON_ERROR_EVENT_UPDATE, payload: ndate.error});
       }
        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_EVENT_UPDATE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//SaveThisSolution
export const SaveThisSolution =  (Afid,userid,Event) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_EVENT_UPDATE});
      axios.put('kontos/Event/updateSol', {
       body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        Event:Event,ipAdress
       }))
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("SaveThisSolution: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("SaveThisSolution1: ", ndate);
        dispatch({type: ON_EVENT_UPDATE, payload: ndate.results});
       }
        else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("SaveThisSolution3: ", ndate);
        dispatch({type: ON_ERROR_EVENT_UPDATE, payload: ndate.error});
        }
        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_EVENT_UPDATE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //BokaAbokaThisEvent
 export const BokaAbokaThisEvent =  (Afid,userid,Event,EStatus,MotesPage) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_EVENT_OMBOKA});
      axios.put('kontos/Event/BokaOm', {
       body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        Event:Event,
        EStatus:EStatus,ipAdress
       }))
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("BokaAbokaThisEvent: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("BokaAbokaThisEvent1: ", ndate);
        dispatch({type: ON_EVENT_UPDATE, payload: ndate.results});
        if(parseInt(MotesPage) === 1){
          dispatch(GetMinaMoteKampanj(Afid,userid))
        }
       }
       else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("BokaAbokaThisEvent3: ", ndate);
        dispatch({type: ON_ERROR_EVENT_UPDATE, payload: ndate.error});
        }
        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_EVENT_UPDATE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//SubmitCommentEvent
export const SubmitCommentEvent =  (Afid,userid,MoteId,Orgnr,item) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_EVENT_COMMENT});
      axios.put('kontos/Event/SubmitComment', {
       body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        MoteId:MoteId,
        item:item,
        Orgnr:Orgnr,ipAdress
       }))
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("SubmitCommentEvent: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("SubmitCommentEvent1: ", ndate);
        dispatch({type: ON_EVENT_COMMENT, payload: ndate.results});
       }
       else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("SubmitCommentEvent3: ", ndate);
        dispatch({type: ON_ERROR_EVENT_COMMENT, payload: ndate.error});
       }
        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_EVENT_COMMENT, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//AvbokaThisEvent
export const AvbokaThisEvent =  (Afid,userid,Event,AvbokaState,MotesPage) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_EVENT_AVBOKA});
      axios.put('kontos/Event/Avboka', {
       body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        Event:Event,
        AvbokaState:AvbokaState,ipAdress
       }))
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("AvbokaThisEvent: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("AvbokaThisEvent1: ", ndate);        
        if(parseInt(MotesPage) === 1){
          dispatch(GetMinaMoteKampanj(Afid,userid))
        }
        dispatch({type: ON_EVENT_AVBOKA, payload: ndate.results});
        }
        else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("AvbokaThisEvent3: ", ndate);
        dispatch({type: ON_ERROR_EVENT_AVBOKA, payload: ndate.error});
        }
        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_EVENT_AVBOKA, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//updateInteralKomment
export const updateInteralKomment =  ( Afid, userid,Orgnr,MoteId,Kommentar) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_EVENT_UPDATE_KOM});
      axios.put('kontos/Event/updateInterKom', {
       body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        MoteId:MoteId,
        Kommentar:Kommentar,ipAdress
       }))
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("updateInteralKomment: ", data);
       if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("updateInteralKomment1: ", ndate);
        dispatch({type: ON_EVENT_UPDATE_KOM, payload: ndate.results});
        dispatch(getMoteByIDRefresh(Orgnr,Afid,userid,MoteId))
        }else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          let ndate = JSON.parse(endata)
          console.log("updateInteralKomment3: ", ndate);
          dispatch({type: ON_ERROR_EVENT_UPDATE_KOM, payload: ndate.error});
        }
      
        //dispatch(getMoteByIDRefresh(Orgnr,Afid,userid,MoteId))
        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_EVENT_UPDATE_KOM, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
export const updateProtokoll =  ( Afid, userid,Orgnr,MoteId,Protokoll, Mottagare=[]) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_EVENT_UPDATE_KOM});
      axios.put('kontos/Event/updateProtokoll', {
       body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        MoteId:MoteId,
        Protokoll:Protokoll,Mottagare:Mottagare,ipAdress
       }))
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("updateProtokoll: ", data);
       if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("updateProtokoll1: ", ndate);
        dispatch({type: ON_EVENT_UPDATE_KOM, payload: ndate.results});
        dispatch(getMoteByIDRefresh(Orgnr,Afid,userid,MoteId))
        }else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          let ndate = JSON.parse(endata)
          console.log("updateProtokoll3: ", ndate);
          dispatch({type: ON_ERROR_EVENT_UPDATE_KOM, payload: ndate.error});
        }
               //dispatch(getMoteByIDRefresh(Orgnr,Afid,userid,MoteId))
        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_EVENT_UPDATE_KOM, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }

 
//updateNyttBefintlig
export const updateNyttBefintlig =  ( Afid, userid,Orgnr,MoteId,newValue) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_EVENT_UPDATE_NYTT});
      axios.put('kontos/Event/updateNyttBe', {
       body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        MoteId:MoteId,
        newValue:newValue,ipAdress
       }))
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("updateNyttBefintlig: ", data);
       if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("updateNyttBefintlig1: ", ndate);
        dispatch({type: ON_EVENT_UPDATE_NYTT, payload: ndate.results});
        dispatch(getMoteByIDRefresh(Orgnr,Afid,userid,MoteId))
        }else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error 
          let endata = decrypt(Data.encryptedData,Data.iv)
          let ndate = JSON.parse(endata)
          console.log("updateNyttBefintlig3: ", ndate);
          dispatch({type: ON_ERROR_EVENT_UPDATE_NYTT, payload: ndate.error});
        }

        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_EVENT_UPDATE_NYTT, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//updateStatusEvent
export const updateStatusEvent =  ( Afid, userid,Orgnr,MoteId,newValue) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_EVENT_UPDATE_NYTT});
      axios.put('kontos/Event/updateStatus', {
       body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        MoteId:MoteId,
        newValue:newValue,ipAdress
       }))
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("updateStatusEvent: ", data);
       if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("updateStatusEvent1: ", ndate);
        dispatch({type: ON_EVENT_UPDATE_NYTT, payload: ndate.results});
        dispatch(getMoteByIDRefresh(Orgnr,Afid,userid,MoteId))
        }else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          let ndate = JSON.parse(endata)
          console.log("updateStatusEvent3: ", ndate);
          dispatch({type: ON_ERROR_EVENT_UPDATE_NYTT, payload: ndate.error});
        }        
        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_EVENT_UPDATE_NYTT, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//
export const updateEventIDKommentar =  ( Afid, userid,Orgnr,MoteId,Kommentar) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_EVENT_UPDATE_NYTT});
    axios.put('kontos/Event/updateKommentar', {
      body: encrypt(JSON.stringify({
       Afid:Afid,
       userid:userid,
       Orgnr:Orgnr,
       MoteId:MoteId,
       Kommentar:Kommentar,
       ipAdress
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }  
    })
    .then( data => {
      console.log("updateUtfallEvent: ", data);
      if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("updateUtfallEvent1: ", ndate);
        dispatch({type: ON_EVENT_UPDATE_NYTT, payload: ndate.results});
        dispatch(getMoteByIDRefresh(Orgnr,Afid,userid,MoteId))
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("updateUtfallEvent3: ", ndate);
        dispatch({type: ON_ERROR_EVENT_UPDATE_NYTT, payload: ndate.error});
      }
      ////dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_EVENT_UPDATE_NYTT, payload: error.message});
          if(!isUndefined(error.response)){
       if (error.response.status === 401) {
         dispatch({type: FETCH_START_SET_UNAUTHE});
        } 
      } 
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
     });
  }
}
//updateUtfallEvent
export const updateUtfallEvent =  ( Afid, userid,Orgnr,MoteId,newValue) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_EVENT_UPDATE_NYTT});
      axios.put('kontos/Event/updateUtfall', {
       body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        MoteId:MoteId,
        newValue:newValue,ipAdress
       }))
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("updateUtfallEvent: ", data);
       if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("updateUtfallEvent1: ", ndate);
        dispatch({type: ON_EVENT_UPDATE_NYTT, payload: ndate.results});
        dispatch(getMoteByIDRefresh(Orgnr,Afid,userid,MoteId))
        }else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          let ndate = JSON.parse(endata)
          console.log("updateUtfallEvent3: ", ndate);
          dispatch({type: ON_ERROR_EVENT_UPDATE_NYTT, payload: ndate.error});
        }
        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_EVENT_UPDATE_NYTT, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//updateEventAvtalID
export const updateEventAvtalID =  ( Afid, userid,Orgnr,MoteId,Avtlaid) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_EVENT_UPDATE_AvtalId});
      axios.put('kontos/Event/updateAvtlaid', {
       body: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        MoteId:MoteId,
        Avtlaid:Avtlaid,ipAdress
       }))
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("updateEventAvtalID: ", data);
       if( data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("updateEventAvtalID1: ", ndate);
        dispatch({type: ON_EVENT_UPDATE_AvtalId, payload: ndate.results});
        dispatch(getMoteByIDRefresh(Orgnr,Afid,userid,MoteId))
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("updateEventAvtalID3: ", ndate);
        dispatch({type: ON_ERROR_EVENT_UPDATE_AvtalId, payload: ndate.error});
      }
      ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_EVENT_UPDATE_AvtalId, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 export const setEventVyType = (Type) => {
  return (dispatch) => {
    dispatch({type:SET_EVENTVY_TYPE,payload:Type});
  }
}
 export const setEventPageRows = (pageRows) => {
  return (dispatch) => {
    dispatch({type:SET_EVENTVY_PAGE_ROWS,payload:pageRows});
  }
}
 export const onCloseEventToaster = () => {
  return (dispatch) => {
    dispatch({type:ON_START_EVENT_UPDATE_NYTT});
  }
}
//getEventDocument
export const getEventDocument =  ( Afid, userid,MoteId) =>{ 
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_EVENT_DOKUMENT});
    axios.get('kontos/Event/document/all',
    { params:encrypt(JSON.stringify({
      Afid:Afid,userid:userid,MoteId:MoteId,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getEventDocument: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("getEventDocument1: ", ndate);
        dispatch({type: ON_GET_EVENT_DOKUMENT, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("getEventDocument3: ", ndate);
        dispatch({type: ON_ERROR_GET_EVENT_DOKUMENT, payload: ndate.error});
      }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_EVENT_DOKUMENT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//AddEventDocument
export const AddEventDocument = (Afid,userid,MoteId,Files) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    var fromdata = new FormData();
    fromdata.append("Afid",Afid)
    fromdata.append("userid",userid)
    fromdata.append("MoteId",MoteId)
    for(let file of Files){
      fromdata.append('files[]', file)
    }
    dispatch({type: ON_START_GET_EVENT_DOKUMENT});
    axios.post('kontos/Event/document/new', 
        fromdata,
        {
          body:{
            MoteId:MoteId,
            Afid:Afid,
            userid:userid,ipAdress
          },
          headers: {
             'Content-Type': 'multipart/form-data',
             'Authorization':   `Bearer ${jwt}`
           }
        }    
    )
    .then(({data}) => {
      if (data.results) {
        dispatch({type: ON_GET_EVENT_DOKUMENT, payload: data.results});
      }else {
        dispatch({type: ON_ERROR_GET_EVENT_DOKUMENT, payload: data.error});
      }
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_GET_EVENT_DOKUMENT, payload: error.message});
      console.log("Error****:", error.message);
    })
  }
}

//getMyCalendarSetting
export const getMyCalendarSetting =  ( userid) =>{ 
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_EVENT_SETTING});
    axios.get('kontos/Event/setting',
    { params:encrypt(JSON.stringify({userid:userid})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getMyCalendarSetting: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("getMyCalendarSetting1: ", ndate);
        dispatch({type: ON_GET_EVENT_SETTING, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        console.log("getMyCalendarSetting3: ", ndate);
        dispatch({type: ON_ERROR_GET_EVENT_SETTING, payload: ndate.error});
      }
      
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_EVENT_SETTING, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//deleteEventDocument 
export const deleteEventDocument = ( Afid,userid,MoteId,deletedDocument) =>{
  const jwt = JSON.parse(localStorage.token);;
  return (dispatch) => {
    dispatch({type: ON_START_GET_EVENT_DOKUMENT});
    axios.delete('kontos/Event/document/delete', {
      method: 'DELETE',
      params: encrypt(JSON.stringify({
        Afid:Afid,
        userid:userid,
        MoteId:MoteId,
        deletedDocument:deletedDocument
      })),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
    })
    .then( data => {
      console.log("deleteEventDocument: ", data);
      if (data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("deleteEventDocument1: ", ndate);
        dispatch({type: ON_GET_EVENT_DOKUMENT, payload: ndate.results});
      }else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)  
        console.log("deleteEventDocument3: ", ndate);
        dispatch({type: ON_ERROR_GET_EVENT_DOKUMENT, payload: ndate.error});
      }
      
    })
    .catch(function (error) {
      dispatch({type: ON_ERROR_GET_EVENT_DOKUMENT, payload: error.message});
      console.log("Error****:", error.message);
    })
  }
}
//onSynkEventOutlookGsuit
export const onSynkEventOutlookGsuit =  (userid,Afid,EventFilterOption,Page,searchWord,pageRows) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_SYNK_ENENTS});
      axios.get('kontos/Event/sync',
      { params:encrypt(JSON.stringify({ Afid:Afid,
        EventFilterOption,
        Page,searchWord,pageRows,
        userid:userid})), 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       )
     .then( data => {
       console.log("onSynkEventOutlookGsuit: ", data);
       if(data.data.success){
         let endata = decrypt(data.data.encryptedData,data.data.iv)
         let ndate = JSON.parse(endata)
         console.log("onSynkEventOutlookGsuit1: ", ndate);
         dispatch({type: ON_SYNK_ENENTS, payload: ndate.results});
       }else{
         let Data = isUndefined(data.data.error)?data.data:data.data.error
         let endata = decrypt(Data.encryptedData,Data.iv)
         let ndate = JSON.parse(endata)
         console.log("onSynkEventOutlookGsuit3: ", ndate);
         dispatch({type: ON_ERROR_SYNK_ENENTS, payload: ndate.error});
       }
      
        ////dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_SYNK_ENENTS, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
      });
    }
 }
 